import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
  useScrollTrigger,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import React from "react";

function ElevationScroll({ children }) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    sx: {
      ...children.props.sx,
      boxShadow: trigger ? "0 1px 0 #E6D5C3" : "none",
    },
  });
}

export function AppToolbar() {
  return (
    <ElevationScroll>
      <AppBar>
        <Container>
          <Toolbar
            disableGutters
            sx={{ minHeight: { xs: 64, sm: 72 }, py: 1, gap: 2 }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                minWidth: 0,
              }}
            >
              <Box
                component="img"
                src="/papasitelogo.png"
                alt="Мастерская в Южном"
                sx={{
                  width: { xs: 48, sm: 56 },
                  height: { xs: 48, sm: 56 },
                  borderRadius: 1,
                  flexShrink: 0,
                }}
              />
              <Typography
                variant="h3"
                sx={{
                  display: { xs: "none", sm: "block" },
                  fontSize: "1.05rem",
                  m: 0,
                }}
              >
                Телемастерская в Южном
              </Typography>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="contained"
              color="primary"
              href="tel:+79040289741"
              startIcon={<PhoneIcon />}
              sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
            >
              <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                +7 (904) 028-97-41
              </Box>
              <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
                Позвонить
              </Box>
            </Button>
          </Toolbar>
        </Container>
      </AppBar>
    </ElevationScroll>
  );
}
